module.exports = __webpack_public_path__ + "img/about-bcfn-video.jpg?af076b1dcee82880cbbe0314b550c6a6";